import { IDelegacion, IPais, Pais } from "@/entities";

export class Delegacion implements IDelegacion {
  clientexdels: any[];
  codDelegacionSol: string;
  codTimezone: string;
  desDelegacion: string;
  active: boolean;
  id: number;
  pais: IPais;

  constructor() {
    this.clientexdels = [];
    this.codDelegacionSol = "";
    this.codTimezone = "";
    this.desDelegacion = "";
    this.active = false;
    this.id = 0;
    this.pais = new Pais();
  }
}
